import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/ads",
  generate: "/ads/generate"
};
